<script>
import { getMissingTimeTrackings } from '@/api/service'
import FormattingHelpers from '@/mixins/FormattingHelpers'
import ActionButtonColumn from '@/components/ui/datatable/columns/ActionButtonColumn.vue'
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex';

export default {
  mixins: [FormattingHelpers],

  data() {
    return {
      columns: [
        {
          field: 'item_order_first_timestamp_date',
          label: '1. Stempeldatum',
          headerAlign: 'left',
          representedAs: row => (row.item_order_first_timestamp_date ? this.formatAsDateTime(row.item_order_first_timestamp_date, 'sql') : '')
        },
        {
          field: 'item_order_id',
          label: 'Vorgangsnummer',
          headerAlign: 'left'
        },
        {
          field: 'item_order_fin',
          label: 'Fahrgestellnummer',
          headerAlign: 'left',
          interpolate: true,
          representedAs: row => (row.item_order_car_id ? `<a href="/cars/${row.item_order_car_id}" target="_blank" class="hover:underline">${row.item_order_fin}</a>` : row.item_order_fin)
        },
        {
          field: 'item_user_lastname',
          label: 'Nachname',
          headerAlign: 'left'
        },
        {
          field: 'item_user_firstname',
          label: 'Vorname',
          headerAlign: 'left'
        },
        {
          field: 'item_time_unit_quantity_stamped_sum',
          label: 'Summe AW gestempelt (ZLS)',
          headerAlign: 'left',
          align: 'right',
          class: 'font-mono',
          representedAs: row => this.formatAsNumber(row.item_time_unit_quantity_stamped_sum)
        },
        {
          label: '',
          field: '',
          sortable: false,
          headerAlign: 'left',
          align: 'right',
          component: ActionButtonColumn,
          meta: {
            actions: [
              {
                label: 'ZE erstellen',
                attrs: {
                  title: 'Zeiterfassungseintrag erstellen'
                },
                onClick: (entry) => {
                  const params = new URLSearchParams()
                  params.append('userId', entry.item_user_id)
                  params.append('awStamped', entry.item_time_unit_quantity_stamped_sum)

                  if (entry.item_order_first_timestamp_date) {
                    params.append('date', DateTime.fromSQL(entry.item_order_first_timestamp_date).toFormat('yyyy-MM-dd'))
                  }

                  if (entry.item_order_fin) {
                    params.append('fin', entry.item_order_fin)
                  }

                  if (entry.item_order_id) {
                    params.append('orderId', entry.item_order_id)
                  }

                  window.open(`/service/zeiterfassung-aw/dashboard?${params.toString()}`)
                }
              }
            ]
          }
        }
      ],
      missingTimeTrackings: []
    }
  },

  computed: {
    ...mapGetters('service', ['globalFilters'])
  },

  created() {
    this.loadMissingTimeTrackings()
  },

  methods: {
    async loadMissingTimeTrackings() {
      this.$wait.start('loading missing time trackings')
      const [error, response] = await getMissingTimeTrackings({
        date_from: this.globalFilters.dateFrom || undefined,
        date_to: this.globalFilters.dateTo || undefined,
        employee: this.globalFilters.mechanic || undefined
      })
      this.$wait.end('loading missing time trackings')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Die fehlenden Einträge in der Zeiterfassung konnten nicht geladen werden']
        })
        return
      }

      this.missingTimeTrackings = response
    }
  }
}
</script>

<template>
  <mia-wait for="loading filters">
    <template #waiting>
      <div class="flex items-center justify-center py-8">
        <mia-wave-loader />
      </div>
    </template>

    <template #default>
      <mia-wait for="loading missing time trackings">
        <template #waiting>
          <div class="flex items-center justify-center py-8">
            <mia-wave-loader />
          </div>
        </template>

        <template #default>
          <datatable
            ref="datatableRef"
            :columns="columns"
            :data="missingTimeTrackings"
            class="sticky w-full table-auto datatable"
          >
            <template #no-results>
              <div class="flex justify-center">
                Keine Einträge gefunden. Super!
              </div>
            </template>
          </datatable>
        </template>
      </mia-wait>
    </template>
  </mia-wait>
</template>
